module.exports = __webpack_public_path__ + "media/images/flags/1x1/ner-ba5a66560f762e378f9dc65042b18734.svg";